<script>

    export default {
        name: "password-strength",

        props: {
            notPassedIconClass: {
                type: String,
                default: 'fa fa-times-circle-o'
            },

            notPassedIconColor: {
                type: String,
                default: '#969EA6'
            },

            passedIconClass: {
                type: String,
                default: 'fa fa-check-circle'
            },

            passedIconColor: {
                type: String,
                default: '#48D597'
            },

            optionalClass: {
                type: String,
                default: 'password-requirements-wrap'
            },

            rules: {
                type: Array
            },

            value: {
                type: String,
                default: ''
            },
        },

        data() {
            return {
                appliedRules: [],
                failedRequiredRule: false,

                notPassedStyle: {
                    color: this.notPassedIconColor
                },

                passedStyle: {
                    color: this.passedIconColor
                }
            }
        },

        watch: {
            rules() {
                this.applyRules('');
            },

            value(value) {
                this.applyRules(value);
            },
        },

        methods: {
            applyRules(value) {
                this.appliedRules = [];
                this.failedRequiredRule = false;
                this.validPassword = false;

                Object.entries(this.rules).forEach(([key, rule]) => {
                    let regex = new RegExp(rule.regex, 'g');
                    let regexTest = regex.test(value);

                    if (!regexTest) {
                        this.failedRequiredRule = true;
                        this.validPassword = false;
                    } else {
                        this.validPassword = true;
                    }

                    this.appliedRules.push({
                        title: rule.description,
                        pass: regexTest
                    });
                });

                this.$emit('password-changed', this.validPassword);
            }
        }
    }
</script>

<template>
    <div :class="optionalClass">
        <div class="password-compliance-title">Password must:</div>
        <ul class="rule-display">
            <li v-for="appliedRule in appliedRules" class="password-reset-rule">
                <span class="co-password-icon">
                    <i v-if="appliedRule.pass" :class="passedIconClass" :style="passedStyle"></i>
                    <i v-else :class="notPassedIconClass" :style="notPassedStyle"></i>
                    {{ appliedRule.title }}
                </span>
            </li>
        </ul>
    </div>
</template>
